export default __webpack_public_path__ + "static/media/run.aba382d9.png";